import React, { useState, useEffect } from 'react';

const ProductSellerTemplateWidget = ({ selectedLayout, isTemplateId, widgetId, numberCounterTabData }) => {
  const { is_website_frontend } = numberCounterTabData || {};
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(false);

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/photo-gallery/temp-css/PhotoGallery.css`;
        if (widgetId) {
          link.setAttribute("photo-gallery-data-dynamic-css", "photo-gallery");
        } else {
          link.setAttribute("data-dynamic-css", "photo-gallery");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="photo-gallery"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

  const images = [
    `${process.env.PUBLIC_URL}/photo-gallery/templates/product-seller/image.png`,
    `${process.env.PUBLIC_URL}/photo-gallery/templates/product-seller/image-1.png`,
    `${process.env.PUBLIC_URL}/photo-gallery/templates/product-seller/image-2.png`,
    `${process.env.PUBLIC_URL}/photo-gallery/templates/product-seller/image-3.png`,
    `${process.env.PUBLIC_URL}/photo-gallery/templates/product-seller/image-4.png`,
  ];

  const changeImage = (index) => {
    setFade(true);
    setTimeout(() => {
      setCurrentIndex(index);
      setFade(false);
    }, 200); // match CSS duration
  };

  const goPrev = () => changeImage(currentIndex > 0 ? currentIndex - 1 : images.length - 1);
  const goNext = () => changeImage(currentIndex < images.length - 1 ? currentIndex + 1 : 0);

  return (
    <div className={`upgadeify photo_gallery product-seller-temp ${is_website_frontend}`}>
      <div className="photo_gallery__widget">
        <div className="carousel__main">
          <div className="carousel__slider carousel__slider--vertical">
            <div className="arrow-btn up" onClick={goPrev}>↑</div>
              <div className='carousel__slider carousel__slider--vertical'>
              {images.map((src, index) => (
              <img
                key={index}
                src={src}
                className={`thumbnail ${index === currentIndex ? 'active' : ''}`}
                onClick={() => changeImage(index)}
                alt={`Thumbnail ${index + 1}`}
              />
            ))}
              </div>
            <div className="arrow-btn down" onClick={goNext}>↓</div>
          </div>

          <div className="main-image-wrapper">
            <div className="arrow-btn left" onClick={goPrev}>←</div>
            <img
              className={`main-image ${fade ? 'fade-out' : 'fade-in'}`}
              src={images[currentIndex]}
              alt="Main"
            />
            <div className="arrow-btn right" onClick={goNext}>→</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSellerTemplateWidget;
